(() => {
  const modal = document.querySelector('[data-casa-list]');
  if (!modal) return;

  const STORAGE_KEY = 'casaListPrompt';
  const DISMISS_DAYS = 30;
  const now = Date.now();
  const startedAt = now;
  let state = {};

  try {
    state = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch (_error) {
    state = {};
  }

  const save = (nextState) => {
    state = { ...state, ...nextState };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (_error) {
      // The signup remains usable when storage is unavailable.
    }
  };

  if (modal.querySelector('[data-casa-list-success]')) {
    save({ subscribedAt: now });
    return;
  }

  if (state.subscribedAt) return;
  if (state.dismissedAt && now - state.dismissedAt < DISMISS_DAYS * 86400000) return;

  const pageViews = Number(state.pageViews || 0) + 1;
  save({ pageViews, lastSeenAt: now });

  let opened = false;
  let engaged = false;
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const delay = pageViews > 1 ? (isMobile ? 35000 : 25000) : (isMobile ? 65000 : 45000);

  const open = () => {
    if (opened || document.visibilityState !== 'visible') return;
    opened = true;
    save({ lastPromptAt: Date.now() });
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  };

  const markEngaged = () => {
    if (engaged) return;
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.45) {
      engaged = true;
      window.removeEventListener('scroll', markEngaged);
      window.setTimeout(open, isMobile ? 8000 : 3000);
    }
  };

  window.addEventListener('scroll', markEngaged, { passive: true });
  window.setTimeout(open, delay);

  if (!isMobile) {
    document.addEventListener('mouseout', (event) => {
      if (event.clientY <= 0 && !event.relatedTarget && Date.now() - startedAt >= 15000) open();
    });
  }

  modal.addEventListener('close', () => {
    if (!modal.querySelector('[data-casa-list-success]')) save({ dismissedAt: Date.now(), lastPromptAt: Date.now() });
  });

  modal.querySelector('[data-casa-list-close]')?.addEventListener('click', () => modal.close());
  modal.querySelector('.casa-list__form')?.addEventListener('submit', () => save({ submittedAt: Date.now() }));
  modal.addEventListener('click', (event) => {
    const bounds = modal.getBoundingClientRect();
    const inside = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
    if (!inside) modal.close();
  });
})();
